import React from 'react';
import breakpointUtils from 'src/utils/breakpointUtils';
import { Button } from './styled';

const isOnMobileDevice = breakpointUtils.isMobileDevice();

// prepend mobile if mobile, capitalize first letter
const getSeleniumName = (name) => {
  const capitalizedName = name.replace(/^\w/, function(chr) {
    return chr.toUpperCase();
  });

  if (isOnMobileDevice) {
    return `mobile${capitalizedName}Button`;
  }
  return `${name}Button`;
};

const ModeButton = ({ name, handleClick }) => (
  <Button
    onClick={handleClick}
    data-selenium={`${getSeleniumName(name)}`}
    name={name}
  />
);

export default ModeButton;
